import { Heart } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function FavoriteButton({ roomId, compact = false }) {
  const { user, refresh } = useAuth();
  if (!user || !user.id || !["coach", "client"].includes(user.role)) return null;
  const isFav = (user.favorites || []).includes(roomId);

  const toggle = async (e) => {
    e.preventDefault(); e.stopPropagation();
    try {
      if (isFav) { await api.delete(`/favorites/${roomId}`); toast.success("Retirée des favoris"); }
      else { await api.post(`/favorites/${roomId}`); toast.success("Salle ajoutée aux favoris — vous serez alerté des nouveaux créneaux"); }
      refresh && refresh();
    } catch { toast.error("Erreur"); }
  };

  return (
    <button data-testid={`favorite-btn-${roomId}`} aria-pressed={isFav} onClick={toggle}
      className={`inline-flex items-center gap-1.5 rounded-full border transition-colors ${compact ? "p-2" : "px-3 py-1.5 text-xs font-semibold"} ${isFav ? "bg-rose-500 text-white border-rose-500" : "bg-white text-slate-600 border-slate-200 hover:border-rose-300 hover:text-rose-600"}`}>
      <Heart className={`w-4 h-4 ${isFav ? "fill-current" : ""}`} />
      {!compact && (isFav ? "Favorite" : "Ajouter aux favoris")}
    </button>
  );
}
